import { surveysConfig } from '../surveys-config';

export const environment = {
  production: true,
  apiURL: 'https://foyapi.azurewebsites.net',
  currentYearSurveyId: surveysConfig.currentYearSurveyId,
  previousYearSurveyId: surveysConfig.previousYearSurveyId,
  readOnlyModeEnabledForSurveyIdList: []
};
